import { FmlxBackdropLoading } from 'fmlx-common-ui';
import React from 'react';
import { BackdropLoadingContext } from './modalContext';

const BackdropLoadingContainer = ({ children }) => {
  const [description, setDescription] = React.useState('Loading...');
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <FmlxBackdropLoading
        show={open}
        showButton={false}
        description={description}
        size={FmlxBackdropLoading.Size.MEDIUM}
      />
      <BackdropLoadingContext.Provider
        value={{
          showBackdropDescription: setDescription,
          showBackdropLoading: setOpen,
        }}
      >
        {children}
      </BackdropLoadingContext.Provider>
    </>
  );
};
export default BackdropLoadingContainer;
